<div class="max-w-md mx-auto p-6 bg-white dark:bg-gray-800 rounded-lg shadow-lg transform transition-all duration-300 hover:scale-105">
    <h1 class="text-2xl mb-4 font-extrabold font-titleAlt text-text dark:text-text-dark">Invite User</h1>
  <form [formGroup]="inviteForm" (ngSubmit)="sendInvite()" class="space-y-4 animate-fadeIn">
    <div>
      <label class="block text-sm font-semibold text-gray-700 dark:text-gray-300">Email:</label>
      <input type="email" formControlName="email" required 
             class="mt-1 block w-full px-3 py-2 bg-white dark:bg-gray-700 border border-gray-300 dark:border-gray-600 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-blue-500 focus:border-blue-500" />
    </div>
    <div>
      <label class="block text-sm font-semibold text-gray-700 dark:text-gray-300">Role:</label>
      <select formControlName="role" 
              class="mt-1 block w-full px-3 py-2 bg-white dark:bg-gray-700 border border-gray-300 dark:border-gray-600 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500">
        @for (item of userRoles(); track $index) {
          <option [value]="item">{{ item }}</option>
        }
      </select>
    </div>
    <div>
      <button type="submit" [disabled]="inviteForm.invalid" 
              class="w-full py-2 px-4 bg-primary hover:bg-red-800 focus:bg-red-600 focus:ring-offset-blue-200 text-white transition ease-in duration-200 text-base font-semibold shadow-md rounded-lg">
        Send Invite
      </button>
    </div>
  </form>
</div>
